import React, { useEffect } from 'react';
import { ReactComponent as Logo } from '../../images/pb_pay_logo.svg';

import styled from 'styled-components';
import { Container } from '@mui/material';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleSuccessToast } from '../../utils/successHandler';
import { toast } from 'react-toastify';
import { TOAST_CONFIG, TOAST_IDS } from '../../const';
import { CircularProgress } from '@mui/material';
import { logger } from '../../utils/logger';
const LeftContent = () => {
  return (
    <WrapperLeft>
      <Logo className="svg" />
    </WrapperLeft>
  );
};

const WrapperLeft = styled.div`
  position: relative;

  .svg {
    width: 80%;
    max-width: 100px;
    height: auto;
  }
`;

const RightContent = () => {
  return (
    <WrapperRight>
      <div className="content">
        <div className="text">
          This will help us recommend products you can use to get started
        </div>
        <img src="/images/onboarding.png" className="gpk" />
      </div>
    </WrapperRight>
  );
};

const WrapperRight = styled.div`
  .content {
    position: relative;
    padding-top: 30%;
    .text {
      max-width: 300px;
    }
    .gpk {
      position: absolute;
      right: 0;
      width: 80%;
      z-index: -1;
      max-width: 200px;
      top: 20%;
    }
  }
`;

const MiddleContent = () => {
  return (
    <MiddleContentWrapper>
      <div>
        <div className="digilocker-wrapper_top">
          <img
            src={require(`../../images/digilocker.png`)}
            className="digilocker"
            alt="Digilocker"
          />
        </div>
        <CircularProgress className="spinner" size={32} thickness={4} />
        <div className="main-message">
          Please wait, your details are being verified from Digilocker.
        </div>
        <div className="sub-message">
          Once verified successfully, you will be redirected to the merchant
          dashboard login page.
        </div>
      </div>
    </MiddleContentWrapper>
  );
};

const MiddleContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 220px;
  text-align: center;
  .card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    padding: 36px 28px 28px 28px;
    max-width: 400px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
  }
  .digilocker-wrapper_top {
    margin-bottom: 8px;
  }
  .digilocker {
    display: inline-block;
    height: 48px;
    margin-top: 0;
  }
  .spinner {
    margin: 8px 0 0 0;
    color: #1976d2;
  }
  .main-message {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 1.5;
  }
  .sub-message {
    font-size: 15px;
    color: #666;
    margin-top: 4px;
    line-height: 1.4;
  }
`;

const Wrapper = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestId');
  const token = queryParams.get('token');
  logger.log(requestId, token);
  const navigate = useNavigate();
  const saveData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ONBOARDING_API_ENDPOINT}/api/v1/digilocker/callback?requestId=${requestId}&token=${token}`,
      {
        headers: {},
      }
    );
    if (response.status === 200) {
      handleSuccessToast('Verification successful');
      setTimeout(() => {
        navigate('/onboarding');
      }, 3000);
    }
    logger.log(response);
  };
  useEffect(() => {
    if (requestId && token) {
      saveData();
    }
  }, [requestId, token]);
  return (
    <OnboardingWrapper>
      <ContentWrapper>
        <div className="col-left">
          <LeftContent />
        </div>
        <div className="col-center">
          <div className="card-wrapper">
            <MiddleContent />
          </div>
        </div>
        <div className="col-right">
          <RightContent />
        </div>
      </ContentWrapper>
    </OnboardingWrapper>
  );
};

const OnboardingWrapper = styled.div`
  min-height: 100vh;
`;
const ContentWrapper = styled(Container)`
  min-height: calc(100vh - 90px);
  padding-top: 50px;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 0 22px;
  .col-left {
    width: 25%;
    max-width: 230px;
  }
  .col-right {
    width: 30%;
  }
  .col-center {
    width: 45%;
    margin-bottom: 30px;
    .card-wrapper {
      padding: 32px;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
  }
  @media all and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 0px;
    .col-left,
    .col-center,
    .col-right {
      width: 100%;
    }
    .col-left {
      max-width: unset;
    }
    .col-right {
      display: none;
    }
    .col-center {
      background: #fff;
      max-width: unset;
      width: calc(100% + 32px);
      margin-left: -16px;
      margin-bottom: 0;
    }
    .card-wrapper {
      margin-top: 80px;
      box-shadow: none;
      border: 0;
      padding-top: 8px !important;
    }
  }
`;

export default Wrapper;
